'use client';
import { useEffect, useState } from 'react';

type ClientProps = {
  updatedAt: string;
};

function Client({ updatedAt }: ClientProps)  {
  const [formatted, setFormatted] = useState<string>('');

  useEffect(() => {
    if (!updatedAt) return;

    const date = new Date(updatedAt);

    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = date.getDate();

    setFormatted(`${formattedTime}, ${month} ${day}`);
  }, [updatedAt]);

  return <>{formatted || '...'}</>;
};

export default Client;
